import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '@/components/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MobileBar from '@/components/feature/MobileBar';
import HeroSection from './components/HeroSection';
import InfoBar from './components/InfoBar';
import AboutSection from './components/AboutSection';
import StructureSection from './components/StructureSection';
import ModalitiesSection from './components/ModalitiesSection';
import ScheduleSection from './components/ScheduleSection';
import PricingSection from './components/PricingSection';
import TestimonialsSection from './components/TestimonialsSection';
import FitnessStoreSection from './components/FitnessStoreSection';
import LocationSection from './components/LocationSection';
import CTASection from './components/CTASection';

export default function Home() {
  const { t } = useTranslation();

  const title = t('seo.home.title');
  const description = t('seo.home.description');
  const keywords = t('seo.home.keywords');
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://topgym.com.br';

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'GymOrSportsActivityLocation',
    name: 'Top Gym Cumbuco',
    description: description,
    url: siteUrl,
    image: 'https://static.readdy.ai/image/c59ecfd5e54a02b33330323f2bdeb10e/221d8c34c1531330f894539ec6c032ae.jpeg?ogv=l5q6a9',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Av. Central, 2211 - Praia de Cumbuco',
      addressLocality: 'Cumbuco',
      addressRegion: 'CE',
      postalCode: '61619-270',
      addressCountry: 'BR',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '-3.6038',
      longitude: '-38.7233',
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '06:00',
        closes: '22:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: 'Saturday',
        opens: '08:00',
        closes: '12:00',
      },
    ],
    telephone: '+55-85-98236-1153',
    priceRange: '$$',
    '@id': `${siteUrl}/#gym`,
  };

  return (
    <div className="min-h-screen bg-background-50">
      <SEO title={title} description={description} keywords={keywords} path="/" schema={schema} />
      <Navbar />
      <main className="overflow-x-hidden pb-20 md:pb-0">
        <HeroSection />
        <InfoBar />
        <AboutSection />
        <StructureSection />
        <ModalitiesSection />
        <ScheduleSection />
        <PricingSection />
        <TestimonialsSection />
        <FitnessStoreSection />
        <LocationSection />
        <CTASection />
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}